export default "/_next/static/images/img4-3f8a455dbf3689ba4fe6a14f7ce07c13.png";